module.exports = __webpack_public_path__ + "static/img/rank-bg.a45181a6.png";